import { IconButton, InputAdornment, MenuItem, TextField, TextFieldProps } from '@mui/material';
import { InformationIcon } from 'assets/icons/InformationIcon';

import { getSelectOrInputFieldSx } from '../Input.style';
import {
  getMenuSx,
  InformationIconButtonStyle,
  LabelContainer,
  SelectChoiceItemOverflowContent,
  SelectFieldContainer,
  SelectInputIconContainer,
} from './SelectInput.style';

export type SelectChoice = {
  label: string;
  value: string | number;
};
export type AdditionalSelectInputProps = {
  startIcon?: JSX.Element;
  preserveSpacingForHelperText?: boolean;
  width?: number;
  choices: SelectChoice[];
  displayEmpty?: boolean;
  onInformationButtonClick?: () => void;
};

export type SelectInputProps = TextFieldProps & AdditionalSelectInputProps;

export const SelectInput = ({
  id,
  name,
  label,
  value,
  onChange,
  error,
  helperText,
  startIcon,
  preserveSpacingForHelperText = true,
  width,
  choices,
  required,
  disabled,
  onInformationButtonClick,
  displayEmpty = false,
}: SelectInputProps): JSX.Element => {
  const selectSx = getSelectOrInputFieldSx(width);
  const menuSx = getMenuSx(width);

  const inputProps = startIcon && {
    startAdornment: (
      <InputAdornment position="start">
        <SelectInputIconContainer>{startIcon}</SelectInputIconContainer>
      </InputAdornment>
    ),
  };

  return (
    <SelectFieldContainer>
      {label && (
        <LabelContainer htmlFor={id}>
          {label + (required ? '*' : '')}
          {onInformationButtonClick && (
            <IconButton onClick={onInformationButtonClick} style={InformationIconButtonStyle}>
              <InformationIcon color="black" />
            </IconButton>
          )}
        </LabelContainer>
      )}
      <TextField
        sx={selectSx}
        id={id}
        name={name}
        value={value}
        select
        onChange={onChange}
        error={error}
        helperText={helperText ?? (preserveSpacingForHelperText ? ' ' : null)}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        SelectProps={{
          MenuProps: {
            sx: menuSx,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          },
          displayEmpty,
        }}
        InputProps={inputProps}
        disabled={disabled}
      >
        {choices.map((choice) => (
          <MenuItem key={choice.value} value={choice.value}>
            <SelectChoiceItemOverflowContent>{choice.label}</SelectChoiceItemOverflowContent>
          </MenuItem>
        ))}
      </TextField>
    </SelectFieldContainer>
  );
};
